import { useMemo } from "react";
import * as THREE from "three";
import { ObjectProps } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const materials = useMemo(() => {
    const baseMaterial = new THREE.MeshBasicMaterial({color: '#523a32'});
    return [
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
    ];
  }, []);

  return (
    <group
      position={position ?? [0, 0, 0]}
      rotation={rotation ?? [0, 0, 0]}
      onPointerEnter={(e) => { e.stopPropagation(); }}
      onPointerLeave={(e) => { e.stopPropagation(); }}
      onClick={(e) => { e.stopPropagation(); }}
    >
      <mesh
        material={materials}
        position={[0, 0, 0]}
        rotation={[0, 0, 0]}
        castShadow
      >
        <boxGeometry args={[9.5, 6.5, 0.1]} />
      </mesh>

      <mesh
        material={materials}
        castShadow
        position={[0, -0.3, 0.15]}
        rotation={[0, 0, 0]}
      >
        <boxGeometry args={[9.4, 5.6, 0.3]} />
      </mesh>
    </group>
  );
}

